import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../shared/utils/const';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-viewapproverremarks',
  templateUrl: './viewapproverremarks.component.html',
  styleUrl: './viewapproverremarks.component.css'
})
export class ViewapproverremarksComponent {
  msMeUserId: string | null=null;
  userType = sessionStorage.getItem('UserType');
  statusList: any[] = [];

  constructor(private apiService: ApiService,
    public dialogRef: MatDialogRef<ViewapproverremarksComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    if (this.userType === 'MSME') {
      this.msMeUserId = sessionStorage.getItem('msMeUserId');
    }
    if (this.userType === 'MSSIDC') {
      this.msMeUserId = data.msmeUserId;
    }
  }

  ngOnInit(): void {
    this.loadStatusAndRemarks();
    
  }

  loadStatusAndRemarks() {
    if (this.userType === 'MSME') {
      var dtoGetRemarksByApprover = {
        msMeUserId: this.msMeUserId
      }
      this.apiService.getRequest(API_ENDPOINTS.MSME.GETAPPROVEREMARKS, dtoGetRemarksByApprover).subscribe(
        result => {
          if (result.status) {
            this.statusList = result.data;
          }
        }
      );
    }

    if (this.userType === 'MSSIDC') {
      var dtoGetRemarksByApprover = {
        msMeUserId: this.msMeUserId
      }
      this.apiService.getRequest(API_ENDPOINTS.MSME.GETAPPROVEREMARKS, dtoGetRemarksByApprover).subscribe(
        result => {
          if (result.status) {
            this.statusList = result.data;
          }
        }
      );
    }

    
  }

  closeDialog(): void {
    this.dialogRef.close();  // Close the dialog
  }
}
